import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeading({ eyebrow, title, subtitle, moreLink, moreText = "查看更多" }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-accent-600">
            <span className="h-1 w-5 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {subtitle && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="inline-flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {moreText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}